<template>
  <ag-form
    :submit-label="$t('general.update')"
    :submit-loading="loading"
    :hide-controls="hasNoChanges"
    @submit="$emit('input', internalValue)"
    @cancel="restoreInternalValue"
  >
    <div v-if="logoPreview" class="text-center">
      <img :src="logoPreview" class="company-logo-preview">
    </div>

    <v-text-field
      v-model="internalValue.companyLogin"
      :rules="$options.rules.companyLogin"
      :label="$t('company.fields.companyLogin')"
      prepend-icon="mdi-key"
      type="text"
    />

    <v-text-field
      v-model="internalValue.displayName"
      :rules="$options.rules.displayName"
      :label="$t('company.fields.displayName')"
      prepend-icon="mdi-domain"
      type="text"
    />

    <ag-user-select
      v-model="internalValue.companyContact"
      :rules="$options.rules.companyContact"
      :label="$t('company.fields.companyContact')"
      :user-list="adminUserList"
      prepend-icon="mdi-account"
    />

    <v-file-input
      :rules="$options.rules.logo"
      :label="$t('company.fields.logo')"
      prepend-icon="mdi-camera"
      @change="onChangeLogo"
    />
  </ag-form>
</template>

<script>
import _isEqual from 'lodash/isEqual'
import Config from 'src/config'

import FormRules from 'src/utils/form-rules'
import Helpers from 'src/utils/helpers'
import Repositories from 'src/repositories'

import AgForm from 'src/components/common/AgForm'
import AgUserSelect from 'src/components/common/AgUserSelect'

export default {
  name: 'MyCompanyForm',
  components: {
    AgForm,
    AgUserSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalValue: {},
    adminUserList: [],
    logoPreview: null,
  }),
  computed: {
    hasNoChanges () {
      return _isEqual(this.value, this.internalValue)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.restoreInternalValue()
      },
    },
  },
  async mounted () {
    const userList = await Repositories.user.getList()
    this.adminUserList = userList.filter(user => user.roles.includes('ADMIN'))
  },
  methods: {
    restoreInternalValue () {
      this.internalValue = Helpers.clone(this.value)
      if (this.value.logo) {
        this.logoPreview = `${Config.API_URL}company/${this.value.id}/logo/${this.value.logo}`
      }
    },
    async onChangeLogo (file) {
      if (file) {
        this.internalValue.logo = file
        this.logoPreview = await this.fileToBase64(file)
      }
    },
    async fileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = event => resolve(event.target.result)
        reader.onerror = error => reject(error)
        reader.readAsDataURL(file)
      })
    },
  },
  rules: {
    companyLogin: [
      FormRules.required('error.form.required'),
      FormRules.minLength('error.form.minLength', { length: 2 }),
      FormRules.maxLength('error.form.maxLength', { length: 15 }),
      FormRules.noSpaces('error.form.noSpaces'),
    ],
    displayName: [
      FormRules.required('error.form.required'),
      FormRules.minLength('error.form.minLength', { length: 2 }),
    ],
    companyContact: [
      FormRules.required('error.form.required'),
    ],
    logo: [],
  },
}
</script>

<style lang="scss" scoped>
  .company-logo-preview {
    max-width: 300px;
    max-height: 100px;
    width: auto;
    height: auto;
  }
</style>
